export enum fetchingTypes {
    SEND_EMAIL = 'SEND_EMAIL',
}
